"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/**
 *  Copyright AlpineReplay Inc, 2021. All rights reserved.
 *  Authors: Brian Bal
 */

/**
 * Device size helpers
 * 
 * @category Atoms
 */
var DeviceSize = function DeviceSize() {
  _classCallCheck(this, DeviceSize);
};

exports.default = DeviceSize;

_defineProperty(DeviceSize, "Default", {
  id: '',
  postfix: ''
});

_defineProperty(DeviceSize, "Mobile", {
  id: 'XS',
  postfix: 'xs'
});

_defineProperty(DeviceSize, "MobileLandscape", {
  id: 'SM',
  postfix: 'sm'
});

_defineProperty(DeviceSize, "Tablet", {
  id: 'MD',
  postfix: 'md'
});

_defineProperty(DeviceSize, "Desktop", {
  id: 'LG',
  postfix: 'lg'
});

_defineProperty(DeviceSize, "All", [DeviceSize.Default, DeviceSize.Mobile, DeviceSize.MobileLandscape, DeviceSize.Tablet, DeviceSize.Desktop]);